import React from "react";
import { Link } from "@/components/common/Link";
import { Button } from "@/components/ui/button";
import { Check, BookOpen, Headphones, ArrowRight, Pizza } from "lucide-react";
export default function GetYourStrategy() {
  return <section data-section-id="40" id="realexample" className="dark bg-black text-foreground py-32 md:py-48 relative overflow-hidden">
      {}
      <div className="absolute top-0 left-0 w-full h-full overflow-hidden pointer-events-none opacity-20">
        <div className="absolute -top-[20%] -right-[10%] w-[600px] h-[600px] rounded-full bg-primary/30 blur-[120px]" />
        <div className="absolute -bottom-[20%] -left-[10%] w-[500px] h-[500px] rounded-full bg-primary/20 blur-[100px]" />
      </div>

      <div className="container mx-auto px-4 relative z-10">
        {}
        <div className="max-w-4xl mx-auto bg-card/10 border border-white/10 rounded-3xl p-8 md:p-16 backdrop-blur-xl shadow-2xl shadow-primary/5 relative">
          
          {}
          <div className="flex justify-center mb-8">
            <div className="p-4 rounded-2xl bg-primary/10 border border-primary/20">
              <Pizza className="w-12 h-12 text-primary animate-pulse" />
            </div>
          </div>

          <div className="text-center space-y-12">
            <h2 className="text-4xl md:text-7xl font-black tracking-tighter text-white font-sans uppercase">
              Real Example
            </h2>
            
            <p className="text-lg md:text-2xl text-muted-foreground max-w-2xl mx-auto leading-relaxed">
              Stop paying full price for solo cravings. See how <span className="text-primary font-bold">HalfOrder</span> turns a <span className="font-mono text-white">$20.00</span> pizza into two <span className="font-mono text-white font-bold">$10.00</span> shares for you and a neighbor.
            </p>

            <Button asChild size="lg" variant="default" className="bg-primary text-primary-foreground text-xl px-12 py-8 h-auto shadow-[0_0_30px_rgba(255,102,0,0.3)] hover:shadow-[0_0_50px_rgba(255,102,0,0.5)] transition-all duration-300 rounded-none font-black uppercase tracking-tighter">
              <Link to="https://testflight.apple.com/join/c7vEQMTQ" newTab>
                download
                <ArrowRight className="ml-3 w-6 h-6" />
              </Link>
            </Button>

            <div className="grid md:grid-cols-2 gap-8 max-w-3xl mx-auto my-12 text-left">
              <div className="bg-white/5 border border-white/10 p-8 rounded-xl backdrop-blur-md shadow-xl transition-transform hover:scale-[1.02] duration-300">
                <div className="flex items-center gap-4 mb-4">
                  <div className="p-3 rounded-full bg-primary/20 text-primary">
                    <BookOpen className="w-6 h-6" />
                  </div>
                  <h3 className="font-bold text-xl tracking-tight text-white">Host an Order</h3>
                </div>
                <p className="text-base text-muted-foreground mb-6">
                  You want a <span className="font-mono text-white font-bold">$24.00</span> sushi platter. Post it, find a match, and pay just <span className="font-mono text-white font-bold">$12.00</span>.
                </p>
                <ul className="space-y-3">
                  <li className="flex items-center gap-3 text-sm">
                    <Check className="w-5 h-5 text-primary" />
                    <span>Earn "Host" reward points</span>
                  </li>
                  <li className="flex items-center gap-3 text-sm">
                    <Check className="w-5 h-5 text-primary" />
                    <span>Choose your pickup spot</span>
                  </li>
                </ul>
              </div>

              <div className="bg-white/5 border border-white/10 p-8 rounded-xl backdrop-blur-md shadow-xl transition-transform hover:scale-[1.02] duration-300">
                <div className="flex items-center gap-4 mb-4">
                  <div className="p-3 rounded-full bg-primary/20 text-primary">
                    <Headphones className="w-6 h-6" />
                  </div>
                  <h3 className="font-bold text-xl tracking-tight text-white">Join an Order</h3>
                </div>
                <p className="text-base text-muted-foreground mb-6">
                  Browse nearby orders. See a <span className="font-mono text-white font-bold">$18.00</span> Thai curry? Join for <span className="font-mono text-white font-bold">$9.00</span> instantly.
                </p>
                <ul className="space-y-3">
                  <li className="flex items-center gap-3 text-sm">
                    <Check className="w-5 h-5 text-primary" />
                    <span>Zero delivery fees</span>
                  </li>
                  <li className="flex items-center gap-3 text-sm">
                    <Check className="w-5 h-5 text-primary" />
                    <span>Real-time chat matching</span>
                  </li>
                </ul>
              </div>
            </div>

            <div className="flex flex-col items-center gap-6 pt-8">
              <div className="inline-flex items-center gap-2 px-4 py-2 rounded-full bg-primary/10 text-primary text-xs font-bold tracking-widest uppercase border border-primary/20">
                <span className="relative flex h-2 w-2">
                  <span className="animate-ping absolute inline-flex h-full w-full rounded-full bg-primary opacity-75"></span>
                  <span className="relative inline-flex rounded-full h-2 w-2 bg-primary"></span>
                </span>
                Live in Toronto
              </div>
              
              <Button asChild size="lg" variant="default" className="bg-primary text-primary-foreground text-xl px-12 py-8 h-auto shadow-[0_0_30px_rgba(255,102,0,0.3)] hover:shadow-[0_0_50px_rgba(255,102,0,0.5)] transition-all duration-300 rounded-none font-black uppercase tracking-tighter">
                <Link to="/DownloadPage">
                  Start Splitting Now
                  <ArrowRight className="ml-3 w-6 h-6" />
                </Link>
              </Button>
              
              <p className="text-sm text-muted-foreground mt-4 font-mono">
                [ 1x Meal / 2x Users = 50% Savings ]
              </p>
            </div>
          </div>
        </div>
      </div>
    </section>;
}